import { Component } from '@angular/core';
import { ToastService } from '../../../common/toast.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-state-header',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './state-header.component.html',
  styleUrl: './state-header.component.scss'
})
export class StateHeaderComponent {
  constructor( private toastService: ToastService,private router: Router,) { }
 goHome() {
    if (this.router.url === '/homepage') {
      this.toastService.showToast('You are already on Webpage', 'success');
    } else {
      this.router.navigateByUrl('/homepage');
    }
  }
}
